module.exports = __webpack_public_path__ + "img/26_155.18f390fa.png";